export default {
    nl: {
        disciplines: {
            title: 'vakgebieden',
            content: `
                <p>Onze subsidies zijn gericht op de vakgebieden:</p>
                <h4>vormgeving</h4>
                <p>Het vakgebied vormgeving strekt zich uit van animatie tot bio design, grafische vormgeving, mode, productontwerp, scenografie, sieraadontwerp en tentoonstellingsontwerp, inclusief disciplines die hieraan raken.</p>
                <h4>architectuur</h4>
                <p>Het vakgebied architectuur wordt gevormd door de disciplines architectuur, interieur, tuin- en landschap, stedenbouw en ruimtelijke ordening.</p>
                <h4>digitale cultuur</h4>
                <p>Het vakgebied digitale cultuur wordt gevormd door ontwerp in relatie tot nieuwe media en technologieën, games, AV-performances, worldbuilding, creative coding, sensory storytelling, art-science, posthumanisme en internetcultuur.</p>
                <p>Binnen de vakgebieden worden verschillende activiteiten uitgevoerd, zowel gericht op het maakproces als op experiment, onderzoek, reflectie en debat.</p>
                <p>Voor elk van deze vakgebieden is er een eigen regeling. De andere subsidies zijn gericht op meerdere vakgebieden en cross-overs daartussen.</p>
            `
        },
        type: {
            title: 'type',
            content: `
                <p>Bij onze <strong>regelingen</strong> kun je een subsidieaanvraag doen voor een project. Als aanvrager bepaal je zelf de thematiek, vraagstelling, opzet, methodiek en welke partners je betrekt bij je project. Onder project verstaan we ook de activiteitenprogramma’s van instellingen.</p>
                <p>De kaders van onze <strong>open oproepen</strong> worden door het Stimuleringsfonds bepaald. We schrijven open oproepen uit om ontwerpers te betrekken bij specifieke, actuele opgaven binnen en buiten de creatieve industrie, maar ook om deelname aan (internationale) evenementen en professionaliseringstrajecten mogelijk te maken.</p>
            `
        },
        applicant: {
            title: 'aanvrager',
            content: `
                <p>Ontwerpers en makers die maximaal vier jaar zijn afgestudeerd aan een relevante ontwerpopleiding of maximaal vier jaar werkervaring hebben in de praktijk, zonder een ontwerpopleiding te hebben afgerond, beschouwen we als startend.</p>
            `
        }
    },
    en: {
        disciplines: {
            title: 'fields of expertise',
            content: `
                <p>Our grants are aimed at the following fields of expertise:</p>
                <h4>design</h4>
                <p>The field of design encompasses a wide range of disciplines, including animation, bio design, graphic design, fashion, product design, scenography, jewellery design, and exhibition design, as well as related fields.</p>
                <h4>architecture</h4>
                <p>The field of architecture includes the disciplines of architecture, interior architecture, garden and landscape architecture, urban planning, and spatial planning.</p>
                <h4>digital culture</h4>
                <p>The field of digital culture includes design in relation to new media and technologies, games, audiovisual performances, worldbuilding, creative coding, sensory storytelling, art-science, posthumanism, and internet culture.</p>
                <p>Various activities are undertaken within these fields, with a focus on the creative process as well as experimentation, research, reflection, and debate.</p>
                <p>Each of these fields of expertise has a dedicated grant scheme. There are also other grant schemes available that span multiple fields of expertise and any crossovers.</p>
            `
        },
        type: {
            title: 'type',
            content: `
                <p>With our <strong>grant schemes</strong>, you can submit a grant application for a project. As the applicant, you yourself decide on the theme, issue, setup, methods and partners you want to involve in your project. Institutional activity programmes are also considered to be projects.</p>
                <p>The frameworks of our <strong>open calls</strong> are determined by the Fund. With our open calls, we invite designers to get involved in specific, current issues within and outside the creative industry, but we also want to make participation in both domestic and international events and professionalization processes possible.</p>
            `
        },
        applicant: {
            title: 'applicant',
            content: `
                <p>Designers and makers who have completed a relevant design study within the last four years or who have at most four years’ practical work experience, without having completed a design study, will be considered to be starting.</p>
            `
        }
    }
};
